let uid = 0;
const GenerateUniqueId = () => {
  return uid++;
};

export default GenerateUniqueId;
